import { Shapes } from '@/components/public/Visualisations/types'
import { Coordinate2D, Path } from '@/types'
import Konva from 'konva'

export class XAxisLabelText extends Konva.Text implements Shapes.Shape {
  static fontSize = 40
  static fontFamily = 'Segoe UI'
  static margin = 70

  key: string = 'x-axis-label-text'
  path: Path = new Path({})
  center: Coordinate2D = this.position()
  capabilities: Shapes.Capability[] = []
  refresh: () => void = () => {}

  constructor() {
    super({
      stroke: '#6C757D',
      fontSize: XAxisLabelText.fontSize,
      fontFamily: XAxisLabelText.fontFamily,
      listening: false,
    })
  }

  update(text: string | undefined, x: number, y: number) {
    if (text) {
      this.visible(true)
      this.text(text)

      this.position({
        x: x - this.width() / 2,
        y: y + XAxisLabelText.margin,
      })

      this.moveToTop()
    } else {
      this.visible(false)
    }
  }
}
